export const config = {
  env: 'production',
  isDev: false,
  apiURI: 'https://app.enty.io/api',
  subscribesURI: 'wss://app.enty.io/api',
  filestorage: 'https://fs.enty.io',
  domainUrl: 'https://pro.enty.io',
  // sentryDsn: 'https://07635677a9b040e59e6ecee0f0f70626@o508566.ingest.sentry.io/5601251',
} as const;
